import React, { useEffect, useState, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const eventsData = [
  {
    id: 1,
    title: "Live Music Show",
    desc: "Enjoy amazing live DJ performances & crowd energy!",
    date: "2025-02-28T18:30:00",
    image: "/images/event1.jpg",
  },
  {
    id: 2,
    title: "Birthday Party",
    desc: "Celebrate with cakes, balloons & unforgettable memories.",
    date: "2025-02-26T19:00:00",
    image: "/images/event2.jpg",
  },
  {
    id: 3,
    title: "Business Meetup",
    desc: "Network with professionals & grow your success.",
    date: "2025-02-20T16:00:00",
    image: "/images/event3.jpg",
  },
  {
    id: 4,
    title: "Business Meetup",
    desc: "Network with professionals & grow your success.",
    date: "2025-02-20T16:00:00",
    image: "/images/event3.jpg",
  },
];

const getTimeLeft = (targetDate) => {
  const total = Date.parse(targetDate) - Date.now();
  const expired = total <= 0;

  return {
    d: expired ? 0 : Math.floor(total / (1000 * 60 * 60 * 24)),
    h: expired ? 0 : Math.floor((total / (1000 * 60 * 60)) % 24),
    m: expired ? 0 : Math.floor((total / (1000 * 60)) % 60),
    s: expired ? 0 : Math.floor((total / 1000) % 60),
    expired
  };
};

export default function EventCard3() {
  const [timers, setTimers] = useState(
    eventsData.map(event => getTimeLeft(event.date))
  );
  const cardRefs = useRef([]);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimers(eventsData.map(event => getTimeLeft(event.date)));
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) entry.target.classList.add("show");
        });
      }, { threshold: 0.2 }
    );

    cardRefs.current.forEach(card => observer.observe(card));
    return () => observer.disconnect();
  }, []);

  return (<>
    <Swiper
      modules={[Navigation, Autoplay]}
      spaceBetween={30}
      navigation
    //   loop
    //   autoplay={{ delay: 3000 }}
      slidesPerView={1}
      breakpoints={{
        768: { slidesPerView: 2 },
        1024: { slidesPerView: 3 },
      }}
      className="event-slider"
    >
      {eventsData.map((event, index) => (
        <SwiperSlide key={event.id}>
          <div className="ec-card hidden" ref={(el) => cardRefs.current[index] = el}>
            <div className="ec-img-wrap">
              <img src={event.image} alt={event.title} className="ec-img" />
            </div>

            {timers[index].expired ? (
              <span className="expired-badge">Expired</span>
            ) : (
              <div className="ec-timer">
                {["Days","Hours","Mins","Secs"].map((lbl, i)=>(
                  <div className="ec-t-box" key={i}>
                    <strong>{Object.values(timers[index])[i]}</strong>
                    <span>{lbl}</span>
                  </div>
                ))}
              </div>
            )}

            <h3 className="ec-title">{event.title}</h3>
            <p className="ec-desc">{event.desc}</p>

            <button disabled={timers[index].expired} className="ec-btn">
              {timers[index].expired ? "Closed" : "View Details"}
            </button>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
    <style>{`.event-slider {
  padding: 40px 0;
}
/* Default Swiper Nav Button Style Override */
.swiper-button-next,
.swiper-button-prev {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: rgba(144, 202, 249,1);
  color: #fff !important;
  transition: 0.3s ease;
}

.swiper-button-next::after,
.swiper-button-prev::after {
  font-size: 18px;
  font-weight: bold;
}

/* Hover Effect */
.swiper-button-next:hover,
.swiper-button-prev:hover {
  background: rgba(144, 202, 249,1);
  transform: scale(1.15);
}

/* Position fix for centered vertical alignment */
.swiper-button-prev {
  left: -10px;
}
.swiper-button-next {
  right: -10px;
}
/* Change arrow icon size */
.swiper-button-next ,
.swiper-button-prev ,.swiper-button-next:hover ,
.swiper-button-prev:hover   {transform:scale(0.5);padding:20px;
  font-size: 10px !important; /* Adjust number to your size */
}
/* Mobile tweaks */
@media (max-width: 768px) {
  .swiper-button-next,
  .swiper-button-prev {
    width: 34px;
    height: 34px;
  }
  .swiper-button-next svg,
  .swiper-button-prev svg {
    font-size: 14px;
  }
}
.hidden {
  opacity: 0;
  transform: translateY(40px);
}
.show {
  opacity: 1;
  transform: translateY(0);
  transition: all .7s ease-out;
}

.ec-card {
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 8px 28px rgba(0,0,0,.1);
  text-align: center;
  overflow: hidden;
  padding-bottom: 20px;
  position: relative;
}

.ec-img {
  width: 100%;
  height: 200px;
  object-fit: cover;
}

.ec-timer {
  background: rgba(144, 202, 249,1);
  color: #fff;
  display: flex;
  justify-content: space-around;
  padding: 10px 0;
}

.ec-t-box strong {
  font-size: 18px;
}

.expired-badge {
  background: #444;
  color: #fff;
  width: 100%;
  display: block;
  padding: 12px;
  font-size: 16px;
  font-weight: bold;
}

.ec-btn {
  background: rgba(144, 202, 249,1);
  color: #fff;
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}
.ec-btn:disabled {
  background: #777;
  cursor: not-allowed;
}
`}</style>
    </>

  );
}
